import { render, staticRenderFns } from "./SelectPixModal.vue?vue&type=template&id=7a8aea58"
import script from "./SelectPixModal.vue?vue&type=script&lang=js"
export * from "./SelectPixModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports